





























import Vue from 'vue';
import {HTTP} from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import {BallPulseLoader} from 'vue-loaders';

export default Vue.component('facility-and-specialty-selector', {
  name: 'FacilityAndSpecialtySelector',
  props: {
    facilityId: {type: Number},
    facilityErrorMessage: {type: String},
    specialtyId: {type: Number},
    specialtyErrorMessage: {type: String},
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  data() {
    return {
      templates: [],
      templateId: null,
      templateName: '',
      loadingFacilitySpecialties: false,
      facilityName: '',
      facilitySpecialtyTypes: [],
      internalSpecialtyId: null as any,
      specialtyName: '',
      timeout: 0 as number,
      showDetails: false
    }
  },
  watch: {
    facilityId() {
      if (this.facilityId) {
        this.getFacilitySpecialties(this.facilityId);
      }
    },
    specialtyId() {
      this.internalSpecialtyId = this.specialtyId;
    }
  },
  methods: {
    async facilitySelected(facility: any) {
      this.facilityName = facility.name;
      if (facility.id !== this.facilityId) {
        this.loadingFacilitySpecialties = true;
        this.$emit('facility-selected', facility);
      }
    },
    async getFacilitySpecialties(facilityId: number) {
      this.loadingFacilitySpecialties = true;
      try {
        const response = await HTTP.get('/api/facilities/' + facilityId + '/specialties');
        if (!response.data || !response.data.data) {
          throw new Error("Error retrieving facility specialties.");
        }
        this.facilitySpecialtyTypes = response.data.data.filter(function (specialty: any) {
          return specialty.facilitySpecialtyAssocId;
        });
        this.loadingFacilitySpecialties = false;
        if (this.specialtyId) {
          this.facilitySpecialtyTypes.forEach((specialty: any) => {
            if (this.specialtyId === specialty.specialtyId) {
              this.specialtyName = specialty.specialtyName;
            }
          });
        }
      } catch (err) {
        console.log(err);
        this.loadingFacilitySpecialties = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred fetching facility specialties.'
        });
      }
    },
    specialtyChange() {
      this.facilitySpecialtyTypes.forEach((specialty: any) => {
        if (this.internalSpecialtyId === specialty.specialtyId) {
          this.specialtyName = specialty.specialtyName;
          this.$emit('specialty-selected', {
            specialtyId: specialty.specialtyId,
            specialtyName: specialty.specialtyName
          });
        }
      });
    },
  }

});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/FacilityAndSpecialtySelector.vue